export default __webpack_public_path__ + "static/media/4-rising-costs.f3d39ba3.png";